export default "__VITE_ASSET__DBIxBpVI__"